import React, {useEffect, useState} from 'react';
import {observer} from 'mobx-react';
import {BaseProps} from "../../../infrastructure/models/props/base-props";
import {UseIoC} from "../composers/composer-plugins/use-ioc";
import {IOC} from "../../../infrastructure/ioc";
import {AppModuleState} from "../../app/models/app-module.state";

class PromotionBannerProps extends BaseProps {
  ioc: IOC;
  competitionId: Number;
  competitorId: Number;
}

export const PromotionBannerComposer = (Component) => UseIoC()(observer(({
                                                                           ioc,
                                                                           competitionId,
                                                                           competitorId,
                                                                           className
                                                                         }: PromotionBannerProps) => {
  const state: AppModuleState = ioc.getInstance(AppModuleState);
  const {isSmallView, promotionBannerModel} = state;
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(promotionBannerModel?.IsValid(state.locale.userCountryId, state.locale.language.id, competitionId, competitorId));
  }, [competitionId, competitorId, promotionBannerModel?.isVisible]);

  const bannerProps = {
    linkModel: promotionBannerModel?.linkModel,
    imageUrl: isSmallView ? promotionBannerModel?.mobileImageUrl : promotionBannerModel?.desktopImageUrl,
    isSmallView,
    className
  }

  return isVisible ? <Component {...bannerProps}/> : null
}));
